import { Divider } from '@blueprintjs/core';
import classes from './CardDivider.module.css';

export function CardDivider() {
  return <Divider className={classes.divider} />;
}
